import { render, staticRenderFns } from "./snackbar.vue?vue&type=template&id=9c40f494&scoped=true"
import script from "./snackbar.vue?vue&type=script&lang=js"
export * from "./snackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c40f494",
  null
  
)

export default component.exports